import { reduce } from '@atlaskit/adf-utils/traverse';
export function countNodes(adfDocument) {
  return reduce(adfDocument, function (acc, node) {
    acc[node.type] = (acc[node.type] || 0) + 1;
    return acc;
  }, {});
}